import { render, staticRenderFns } from "./Tops.vue?vue&type=template&id=60e81746&scoped=true&"
import script from "./Tops.vue?vue&type=script&lang=js&"
export * from "./Tops.vue?vue&type=script&lang=js&"
import style0 from "./Tops.vue?vue&type=style&index=0&id=60e81746&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60e81746",
  null
  
)

export default component.exports